// src/api/axiosInstance.js
import axios from "axios";
import { useCounterStore } from "../stores/counterStore"; // 导入 Pinia Store
import router from "../router"; // 导入路由实例

// 创建 Axios 实例
const axiosInstance = axios.create({
  baseURL: "https://test.qxz.mfy777.com", // 设置基础 URL
  timeout: 60000, // 设置请求超时时间（已由10秒调整为60秒，解决列表请求过大时超时的问题）
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    const store = useCounterStore(); // 使用 Pinia Store
    const token = store.token; // 从 Pinia Store 获取 token

    if (token) {
      config.headers["token"] = `${token}`; // 将 token 添加到请求头
    }
    return config; // 返回配置
  },
  (error) => {
    console.error("Request error:", error); // 打印错误信息
    return Promise.reject(error); // 返回错误
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    // 检查登录失效的情况
    if (response.data.code === 10000 || 
        (response.data.message && response.data.message.includes('not login')) ||
        (response.data.type === 39)) {
      const store = useCounterStore();
      store.clearToken(); // 清空 token
      localStorage.removeItem("userInfo"); // 清空用户信息
      localStorage.removeItem("ImInfo"); // 清空IM信息
      router.push("/"); // 跳转到登录页
      return Promise.reject(new Error('登录已失效，请重新登录'));
    }

    return response.data; // 返回响应数据
  },
  (error) => {
    console.error("Response error:", error); // 打印错误信息
    return Promise.reject(error); // 返回错误
  }
);

export default axiosInstance;
